<template>
  <div class="condition-multi-select condition-form-item">
    <el-divider />

    <p class="input-label">{{ config.name }}</p>
    <el-select v-model="connection" size="medium">
      <el-option
        v-for="item in multiOperations"
        :key="item.code"
        :label="item.name"
        :value="item.code"
      ></el-option>
    </el-select>
    <el-select v-model="multiSelectedIds" size="medium" multiple>
      <el-option v-for="item in operations" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object
    }
  },
  computed: {
    operations() {
      if (this.config.valueFrom === "direct") {
        return this.config.selectValue;
      }
    },
    multiSelected() {
      var obj = this.operations.filter(item => {
        this.multiSelectedIds.indexOf(item.id) > -1;
      });
      return this.obj;
    }
  },
  watch: {
    connection: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        console.log(newValue);
      }
    }
  },
  created() {
    console.log(1);
  },
  data() {
    return {
      multiOperations: multiOperations,
      connection: "",
      multiSelectedIds: []
    };
  }
};
</script>

<style scoped lang="scss">
@import "../common.scss";
</style>